import { toLower } from 'lodash'
import ApiTestInterface, { ApiTestRequestParams } from '../ApiTestInterface'
import Rest from '../Rest'

export default class V1Service extends Rest implements ApiTestInterface {
  /**
   * @type {String}
   */
  static resource = '/api/v1'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  search(params?: ApiTestRequestParams) {
    return this.get('test/search', params)
  }

  notFound(method) {
    return this[toLower(method)]('test/notfound')
  }
}
